module.exports = __webpack_public_path__ + "files/b387a7359cb253ef8c6b58fdf38aeddf.svg";